import { LatLng } from 'leaflet';
import BodyContract from '@/marker/BodyContract';
import CategoryContract from '@/category/CategoryContract';
import ImageContract from '@/image/ImageContract';
import MarkerContract from '@/marker/MarkerContract';

export default abstract class AbstractMarkerDecoractor implements MarkerContract {
    protected origin: MarkerContract;

    constructor(origin: MarkerContract) {
        this.origin = origin;
    }

    public get id(): string {
        return this.origin.id;
    }

    public get title(): string {
        return this.origin.title;
    }

    public get subtitle(): string | null {
        return this.origin.subtitle;
    }

    public get marker_promoted(): boolean | false {
        return this.origin.marker_promoted;
    }

    public get category(): CategoryContract {
        return this.origin.category;
    }

    public get image(): ImageContract {
        return this.origin.image;
    }

    public get marker_body(): BodyContract {
        return this.origin.marker_body;
    }

    public get marker__type(): string {
        return this.origin.marker__type;
    }

    public latLng(): LatLng {
        return this.origin.latLng();
    }

    public slug(): string {
        return this.origin.slug();
    }
}
